var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"top"},[_c('NavTabs'),_c('div',{staticClass:"flex-center"},[_c('cardReader'),_c('currentOrg'),_c('el-divider',{attrs:{"direction":"vertical"}}),_c('currentUser')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }